function handleWindowPopUp(url, target = "_blank") {
  const n = window.open(url, target);
  if (!n || n.closed || typeof n.closed=='undefined') {
    return false;
  }
  return true;
}

export default handleWindowPopUp;
